const key = (value) => String(value ?? "").trim().toLowerCase();

export const ioRecipientUserId = (row = {}) =>
  String(
    row.RecipientCrmId ??
      row.RecipientUserId ??
      row.RecipientId ??
      row.AdviserId ??
      "",
  ).trim();

export const groupUnmatchedIoPayments = (rows = [], matchedRecipientIds = []) => {
  const matched = new Set(matchedRecipientIds.map(key).filter(Boolean));
  const grouped = new Map();

  rows.forEach((row) => {
    const recipientUserId = ioRecipientUserId(row);
    const recipientKey = key(recipientUserId);
    if (!recipientKey || matched.has(recipientKey)) return;

    const current = grouped.get(recipientKey) || {
      recipientUserId,
      recipientName: String(row.Recipient || "").trim() || `IO User ${recipientUserId}`,
      total: 0,
      paymentCount: 0,
    };
    current.total += Number(String(row.PaymentAmount ?? 0).replace(/[,£]/g, "")) || 0;
    current.paymentCount += 1;
    if (!current.recipientName && row.Recipient) {
      current.recipientName = String(row.Recipient).trim();
    }
    grouped.set(recipientKey, current);
  });

  return [...grouped.values()].sort((left, right) =>
    left.recipientName.localeCompare(right.recipientName, "en-GB", {
      numeric: true,
    }),
  );
};

